import { app } from '../../../../app';
import { Controller } from './sharing-center-reports.controller';

app.component('sharingCenterReport', {
	bindings: {
		currentCompany: '<',
        sharedAccounts: '<',
    },
    controller: Controller,
    templateUrl: require('./sharing-center-reports.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/sharing-center-reports/sharing-center-reports.component.js